import script from "./ManageScheduling.vue?vue&type=script&setup=true&lang=ts"
export * from "./ManageScheduling.vue?vue&type=script&setup=true&lang=ts"

import "./ManageScheduling.vue?vue&type=style&index=0&id=2d33350c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d33350c"]])

export default __exports__